'use client';

import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import { TrackedButton } from '@/components/button/tracked-button';
import { submitInquiry } from '@/components/inquiry-funnel/server/submit-inquiry';
import { customRichTextTags } from '@/utils/i18n';
import CtaBox, {
  CTA_BOX_BUTTON_CLASSNAME,
  CTA_BOX_BUTTON_TEXT_CLASSNAME,
} from './cta-box';

// framer-motion 을 포함한 무거운 퍼널을 별도 청크로 분리한다.
// InquiryFunnel 은 뷰포트(useMediaQuery)로 레이아웃을 분기해 SSR 시 hydration
// mismatch 가 나므로 ssr:false 로 클라이언트 전용 로드한다.
// 다른 문의 CTA 는 전부 채널톡으로 전환됐지만, 본문 삽입형인 이 CTA 만 남아 있다
// (블로그 CTA 도 전환할지는 별도 결정 필요 — src/components/inquiry-funnel 이 여전히
// 쓰이는 유일한 지점).
const InquiryFunnel = dynamic(
  () => import('@/components/inquiry-funnel').then(m => m.InquiryFunnel),
  { ssr: false, loading: () => null },
);

// gtag generate_lead 리드 소스 라벨 (다중 삽입과 무관하게 고정)
const INQUIRY_LEAD_LABEL = 'blog_inquiry_cta';

export interface InquiryCtaProps {
  label: string;
  index: number;
}

/**
 * 본문 안에 들어가는 문의 CTA. 버튼 문구만 MDX 의 `label` prop 을 그대로 쓴다 —
 * 기존 본문을 고치지 않고 박스를 입히기 위해서다.
 */
const InquiryCta = ({ label, index }: InquiryCtaProps) => {
  const t = useTranslations('Blog.main.inquiryCta');

  return (
    <CtaBox
      title={t.rich('title', customRichTextTags)}
      description={t('description')}
    >
      {/* 버튼은 InquiryFunnel(ssr:false)이 클라이언트에서 마운트된 뒤 나타나므로,
          동일 높이를 예약해 마운트 전후 layout shift 를 방지한다. */}
      <div className="flex min-h-10 justify-center xl:min-h-12">
        <InquiryFunnel
          trigger={
            <TrackedButton
              type="button"
              label={`${INQUIRY_LEAD_LABEL}_${index + 1}`}
              position="main_cta"
              className={CTA_BOX_BUTTON_CLASSNAME}
            >
              <span className={CTA_BOX_BUTTON_TEXT_CLASSNAME}>{label}</span>
            </TrackedButton>
          }
          onSubmit={submitInquiry}
          leadLabel={INQUIRY_LEAD_LABEL}
        />
      </div>
    </CtaBox>
  );
};

export default InquiryCta;
